import { Route, Routes } from 'react-router-dom';
import React from 'react';
import Shell from './shell/shell';
import { MyTripsPage } from './pages/tripCollections/myTripsPage';
import { FavoritesPage } from './pages/tripCollections/favoritesPage';
import { EditTripPage } from './pages/editTrip/editTripPage';
import { SilentRefresh } from './components/silentRefresh';
import { ProfilePage } from './pages/profile/profilePage';
import { AccountPage } from './pages/account/accountPage';
import { LoginPage } from './pages/login/loginPage';
import { SignOutPage } from './pages/signout';
import NotFoundPage from './pages/notFound/notFoundPage';
import { TripPage } from './pages/trip/tripPage';
import NotificationsPage from './pages/notifications/notificationsPage';
import { useTrackPageView } from './hooks/trip/useTrackPageView';

const navElements = [
  {
    element: MyTripsPage,
    href: '/',
  },
  {
    element: FavoritesPage,
    href: '/favorites',
  },
  {
    element: EditTripPage,
    href: '/trips/:tripId',
  },
  {
    element: ProfilePage,
    href: '/profile/:userId',
  },
  {
    element: AccountPage,
    href: '/account',
  },
  {
    element: TripPage,
    href: '/trip/*',
  },
  {
    element: TripPage,
    href: '/p/trip/*',
  },
  {
    element: LoginPage,
    href: '/login',
  },
  {
    element: SignOutPage,
    href: '/signout',
  },
  {
    element: NotificationsPage,
    href: '/notifications',
  },
  {
    element: NotFoundPage,
    href: '/*',
  },
];

const App = () => {
  useTrackPageView();

  return (
    <>
      <SilentRefresh />
      <Shell>
        <Routes>
          {navElements.map((nav) => (
            <Route key={`route-${nav.href}`} path={nav.href} element={<nav.element />} />
          ))}
        </Routes>
      </Shell>
    </>
  );
};

export default App;
